<template>
  <v-container>
    <v-navigation-drawer
      app
      permanent
      clipped
      class="elevation-5"
      width="100px"
    >
      <!-- sidebar buttons -->
      <v-item-group style="height: 80%" class="overflow-y" mandatory>
        <v-container fluid>
          <v-row>
            <v-col
              class="px-0 pb-1 pt-0"
              cols="12"
              v-for="(type, key) in types"
              :key="key"
            >
              <transition name="dropdown">
                <v-item v-slot:default="{ active, toggle }">
                  <v-card
                    elevation="0"
                    rounded="0"
                    :class="[
                      active ? 'line-border' : 'line-holder',
                      'align-center',
                    ]"
                    @click="toggleUser(toggle, type.name)"
                  >
                    <v-list class="py-0" dense>
                      <v-list-item>
                        <v-list-item-content
                          :class="`my-2 py-0 text-center font-weight-medium ${
                            active ? 'primary' : 'grey'
                          }--text`"
                        >
                          <v-img
                            :src="active ? type.icon_active : type.icon"
                          ></v-img>
                          <v-list-item-title class="mt-1">{{
                            type.name
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-item>
              </transition>
            </v-col>
          </v-row>
        </v-container>
      </v-item-group>
    </v-navigation-drawer>
    <v-row v-if="sidebarItem === 'Doctors'">
      <v-col cols="12">
        <v-row>
          <v-col cols="12">
            <base-title no-margin-top>Supervisors on Shift</base-title>
          </v-col>
          <v-col cols="12">
            <supervisor-item
              v-for="name in supervisors"
              :key="name"
              :name="name"
            ></supervisor-item>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-row>
          <v-col cols="12">
            <div
              class="d-flex justify-space-between align-center align-content-center"
            >
              <base-title no-margin-top>Doctors on Shift</base-title>
              <v-spacer></v-spacer>
              <v-menu offset-y>
                <!-- status menu activator -->
                <template v-slot:activator="{ on }">
                  <v-btn
                    text
                    :color="doctorFilterStatus.iconColor"
                    v-on="on"
                    :loading="isGetDoctorsStart"
                  >
                    <span>
                      <v-icon x-small :color="doctorFilterStatus.iconColor">
                        mdi-circle
                      </v-icon>
                      <span v-show="$vuetify.breakpoint.mdAndUp">
                        {{ doctorFilterStatus.status }}
                      </span>
                      <v-icon>mdi-menu-down</v-icon>
                    </span>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item-group>
                    <v-list-item
                      v-for="(item, key) in statuses"
                      :key="key"
                      :value="item.status"
                      @click="selectDoctorFilterStatus(item)"
                      dense
                    >
                      <v-list-item-icon class="mx-0">
                        <v-icon x-small :color="item.iconColor">
                          mdi-circle
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-content
                        v-text="item.status"
                        class="ma-0 pa-0"
                      >
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-menu>
            </div>
          </v-col>
          <v-col cols="12">
            <div
              class="d-flex justify-space-around align-center align-content-center"
            >
              <base-title no-margin-top
                >Total Doctors:
                <span v-if="!isGetDoctorsStart">{{ totalDoctorsCount }}</span>
                <v-progress-circular
                  :size="15"
                  :width="2"
                  indeterminate
                  color="primary"
                  v-if="isGetDoctorsStart"
                  class="ml-1"
                ></v-progress-circular
              ></base-title>
              <base-title no-margin-top
                >Total Online:
                <span v-if="!isGetDoctorsStart">{{ totalDoctorsOnline }}</span>
                <v-progress-circular
                  :size="15"
                  :width="2"
                  indeterminate
                  color="primary"
                  v-if="isGetDoctorsStart"
                  class="ml-1"
                ></v-progress-circular
              ></base-title>
              <base-title no-margin-top
                >Total In Call:
                <span v-if="!isGetDoctorsStart">{{ totalDoctorsInCall }}</span>
                <v-progress-circular
                  :size="15"
                  :width="2"
                  indeterminate
                  color="primary"
                  v-if="isGetDoctorsStart"
                  class="ml-1"
                ></v-progress-circular
              ></base-title>
            </div>
          </v-col>
          <v-col cols="12" v-if="isGetDoctorsStart">
            <user-skeleton-loaders></user-skeleton-loaders>
          </v-col>
          <v-col cols="12" v-if="!isGetDoctorsStart">
            <v-row>
              <template v-for="(doctor, index) in filteredDoctors">
                <v-col cols="12" md="3" :key="index">
                  <user-card :user="doctor"></user-card>
                </v-col>
              </template>
            </v-row>
          </v-col>
          <v-col cols="12" v-if="noDoctors">
            <div class="text-center grey--text subtitle-2 font-weight-regular">
              No data available.
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-if="sidebarItem === 'Agents'">
      <v-col cols="12">
        <v-row>
          <v-col cols="12">
            <base-title no-margin-top>Supervisors on Shift</base-title>
          </v-col>
          <v-col cols="12">
            <supervisor-item
              v-for="name in supervisors"
              :key="name"
              :name="name"
            ></supervisor-item>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-row>
          <v-col cols="12">
            <div
              class="d-flex justify-space-between align-center align-content-center"
            >
              <base-title no-margin-top>Agents on Shift</base-title>
              <v-spacer></v-spacer>
              <v-menu offset-y>
                <!-- status menu activator -->
                <template v-slot:activator="{ on }">
                  <v-btn text :color="tmaFilterStatus.iconColor" v-on="on">
                    <span>
                      <v-icon x-small :color="tmaFilterStatus.iconColor">
                        mdi-circle
                      </v-icon>
                      <span v-show="$vuetify.breakpoint.mdAndUp">
                        {{ tmaFilterStatus.status }}
                      </span>
                      <v-icon>mdi-menu-down</v-icon>
                    </span>
                  </v-btn>
                </template>
                <!-- status menu item -->
                <v-list>
                  <v-list-item-group>
                    <v-list-item
                      v-for="(item, key) in statuses"
                      :key="key"
                      :value="item.status"
                      @click="selectTmaFilterStatus(item)"
                      dense
                    >
                      <v-list-item-icon class="mx-0">
                        <v-icon x-small :color="item.iconColor">
                          mdi-circle
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-content
                        v-text="item.status"
                        class="ma-0 pa-0"
                      >
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-menu>
            </div>
          </v-col>
          <v-col cols="12">
            <div
              class="d-flex justify-space-around align-center align-content-center"
            >
              <base-title no-margin-top
                >Total Agents:
                <span v-if="!isGetAgentsStart">{{ totalTmaCount }}</span>
                <v-progress-circular
                  :size="15"
                  :width="2"
                  indeterminate
                  color="primary"
                  v-if="isGetAgentsStart"
                  class="ml-1"
                ></v-progress-circular
              ></base-title>
              <base-title no-margin-top
                >Total Online:
                <span v-if="!isGetAgentsStart">{{ totalTmaOnline }}</span>
                <v-progress-circular
                  :size="15"
                  :width="2"
                  indeterminate
                  color="primary"
                  v-if="isGetAgentsStart"
                  class="ml-1"
                ></v-progress-circular
              ></base-title>
              <base-title no-margin-top
                >Total In Call:
                <span v-if="!isGetAgentsStart">{{ totalTmaInCall }}</span>
                <v-progress-circular
                  :size="15"
                  :width="2"
                  indeterminate
                  color="primary"
                  v-if="isGetAgentsStart"
                  class="ml-1"
                ></v-progress-circular
              ></base-title>
            </div>
          </v-col>
          <v-col cols="12" v-if="isGetAgentsStart">
            <user-skeleton-loaders></user-skeleton-loaders>
          </v-col>
          <v-col cols="12" v-if="!isGetAgentsStart">
            <v-row>
              <template v-for="(tma, index) in filteredTma">
                <v-col cols="12" md="3" :key="index">
                  <user-card :user="tma"></user-card>
                </v-col>
              </template>
            </v-row>
          </v-col>
          <v-col cols="12" v-if="noTma">
            <div class="text-center grey--text subtitle-2 font-weight-regular">
              No data available.
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- main container -->
    <!--    <v-row class="mt-0 py-0">-->
    <!--      &lt;!&ndash; users on shift &ndash;&gt;-->
    <!--      <v-col cols="3" class="py-0" style="position: fixed;">-->
    <!--        <sidebar-schedule-->
    <!--          :type="sidebarItem"-->
    <!--          :users="this.sidebarItem === 'Doctors' ? this.doctors : this.tma"-->
    <!--        ></sidebar-schedule>-->
    <!--      </v-col>-->

    <!--      <v-col cols="9" class="pr-7 pt-6" style="position: absolute; right: 0;">-->
    <!--        &lt;!&ndash; supervisors on shift &ndash;&gt;-->
    <!--        <base-title-->
    <!--          no-margin-top-->
    <!--        >-->
    <!--          Supervisors on shift-->
    <!--        </base-title>-->
    <!--        <div class="mt-2">-->
    <!--          <supervisor-item-->
    <!--            v-for="name in supervisors"-->
    <!--            :key="name"-->
    <!--            :name="name" -->
    <!--          ></supervisor-item>-->
    <!--        </div>-->

    <!--        &lt;!&ndash; doctors table &ndash;&gt;-->
    <!--        <v-row align="center" class="mt-5">-->
    <!--          <v-col cols="6">-->
    <!--            <base-title-->
    <!--              no-margin-top-->
    <!--            >-->
    <!--              December 13, Friday-->
    <!--            </base-title>-->
    <!--          </v-col>-->
    <!--          <v-col cols="6" class="justify-end d-flex">-->
    <!--            <v-btn icon @click="toggleView('grid')">-->
    <!--              <v-icon-->
    <!--                :color="view.grid?'primary':''"-->
    <!--              >-->
    <!--                mdi-view-grid-->
    <!--              </v-icon>-->
    <!--            </v-btn>-->
    <!--            <v-btn icon @click="toggleView('sequential')">-->
    <!--              <v-icon-->
    <!--                size="30"-->
    <!--                :color="view.sequential?'primary':''"-->
    <!--              >-->
    <!--                mdi-view-sequential-->
    <!--              </v-icon>-->
    <!--            </v-btn>-->
    <!--          </v-col>-->

    <!--          &lt;!&ndash; grid view &ndash;&gt;-->
    <!--          <v-row v-if="view.grid" class="px-3 overflow-y" style="height: 64vh;">-->
    <!--            <v-col cols="4"-->
    <!--              v-for="(schedule, key) in schedules"-->
    <!--              :key="key"-->
    <!--            >-->
    <!--              <schedule-card-->
    <!--                :time="schedule"-->
    <!--              ></schedule-card>-->
    <!--            </v-col>-->
    <!--          </v-row>-->

    <!--          &lt;!&ndash; sequential view &ndash;&gt;-->
    <!--          <v-row v-else class="px-3 overflow-y" style="height: 64vh;">-->
    <!--            <table>-->
    <!--              <thead>-->
    <!--                <tr>-->
    <!--                  <th class="time">Time</th>-->
    <!--                  <th>IBD</th>-->
    <!--                  <th>Approx. Q Depth</th>-->
    <!--                  <th>OBD</th>-->
    <!--                  <th>Calls</th>-->
    <!--                  <th>OB Agents</th>-->
    <!--                  <th>Approx. Q Depth</th>-->
    <!--                  <th>IB Agents</th>-->
    <!--                  <th>Available for call</th>-->
    <!--                </tr>-->
    <!--              </thead>-->
    <!--              <tbody-->
    <!--                v-for="(schedule, key) in schedules"-->
    <!--                :key="key"-->
    <!--              >-->
    <!--                <schedule-row-->
    <!--                  :time="schedule"-->
    <!--                  :grey="key%2"-->
    <!--                ></schedule-row>-->
    <!--              </tbody>-->
    <!--            </table>-->
    <!--          </v-row>-->
    <!--        </v-row>-->
    <!--      </v-col>-->
    <!--    </v-row>-->
    <!--    -->
  </v-container>
</template>

<script>
import API from "@/api";
import UserSkeletonLoaders from "@/views/admin/Dashboard/components/UserSkeletonLoaders";
const User = API.get("User");

export default {
  name: "Dashboard",

  components: {
    UserSkeletonLoaders,
    // SidebarSchedule: () => import("./components/SidebarSchedule.vue"),
    // ScheduleCard: () => import("./components/ScheduleCard.vue"),
    // ScheduleRow: () => import("./components/ScheduleRow.vue"),
    SupervisorItem: () => import("./components/SupervisorItem.vue"),
    UserCard: () => import("./components/UserCard"),
  },

  data: () => ({
    view: {
      grid: true,
      sequential: false,
    },
    sidebarItem: "Doctors",
    schedules: [
      "08:00",
      "08:20",
      "08:40",
      "09:00",
      "09:20",
      "09:40",
      "10:00",
      "10:20",
      "10:40",
      "11:00",
      "11:20",
      "11:40",
    ],
    supervisors: ["Robert Downy Jr.", "Andres Bonifacio", "Elizabeth Bayon"],
    doctors: [],
    tma: [],
    active: "doctors",
    types: [
      {
        name: "Doctors",
        type: "doctor",
        icon_active: require("@/assets/doctor_blue.png"),
        icon: require("@/assets/doctor_grey.png"),
      },
      {
        name: "Agents",
        type: "tma",
        icon_active: require("@/assets/agent_blue.png"),
        icon: require("@/assets/agent_grey.png"),
      },
    ],
    totalDoctorsCount: 0,
    totalDoctorsOnline: 0,
    totalDoctorsInCall: 0,
    isGetDoctorsStart: false,
    isGetAgentsStart: false,
    doctorFilterStatus: {
      iconColor: "green",
      status: "All",
      value: "all",
    },
    tmaFilterStatus: {
      iconColor: "green",
      status: "All",
      value: "all",
    },
    totalTmaCount: 0,
    totalTmaOnline: 0,
    totalTmaInCall: 0,
  }),

  computed: {
    filteredDoctors() {
      const { value } = this.doctorFilterStatus;
      if (value === "all") return this.doctors;
      return this.doctors.filter((doctor) => doctor.status === value);
    },

    noDoctors() {
      return this.filteredDoctors.length === 0 && !this.isGetDoctorsStart;
    },

    filteredTma() {
      const { value } = this.tmaFilterStatus;
      if (value === "all") return this.tma;
      return this.tma.filter((tma) => tma.status === value);
    },

    noTma() {
      return this.filteredTma.length === 0 && !this.isGetAgentsStart;
    },

    statuses() {
      return [
        {
          iconColor: "green",
          status: "All",
          value: "all",
        },
        {
          iconColor: "yellow darken-2",
          status: "In call",
          value: "in call",
        },
        {
          iconColor: "blue",
          status: "After call work",
          value: "after call work",
        },
        {
          iconColor: "green",
          status: "Available",
          value: "available",
        },
        {
          iconColor: "green",
          status: "Online",
          value: "online",
        },
        {
          iconColor: "red",
          status: "Do not disturb",
          value: "do not disturb",
        },
        {
          iconColor: "red",
          status: "On break",
          value: "on break",
        },
        {
          iconColor: "red",
          status: "End of shift",
          value: "end of shift",
        },
        {
          iconColor: "gray",
          status: "Offline",
          value: "offline",
        },
        {
          iconColor: "gray",
          status: "Away",
          value: "away",
        },
      ];
    },
  },

  methods: {
    toggleUser(toggle, type) {
      if (this.sidebarItem !== type) {
        toggle();
        this.sidebarItem = type;
      }
    },

    async getDoctors() {
      this.isGetDoctorsStart = true;
      try {
        const allDoctors = await User.getDoctors(null, { search: "" });
        this.totalDoctorsCount = allDoctors.data.total;
        const response = await User.getDoctors(allDoctors.data.total);
        this.doctors = response.data.data
          .filter((doctor) => doctor.doctor)
          .map((user) => ({
            name:
              user.doctor.fullname ||
              `${user.doctor.first_name} ${user.doctor.last_name}`,
            status: user.doctor.status
              ? user.doctor.status.toLowerCase()
              : "offline",
          }));
        this.totalDoctorsOnline =
          this.doctors.filter((doctor) => doctor.status === "online").length ||
          0;
        this.totalDoctorsInCall =
          this.doctors.filter((doctor) => doctor.status === "in call").length ||
          0;
      } catch (error) {
        this.doctors = [];
      }
      this.isGetDoctorsStart = false;
    },

    async getAgents() {
      this.isGetAgentsStart = true;
      try {
        const response = await User.getAgents();
        const result = response.data.data;
        this.tma = result.map((user) => ({
          name:
            user.tma.fullname || `${user.tma.first_name} ${user.tma.last_name}`,
          status: user.tma.status ? user.tma.status.toLowerCase() : "offline",
        }));
        this.totalTmaCount = this.tma.length;
        this.totalTmaOnline =
          this.tma.filter((tma) => tma.status === "online").length || 0;
        this.totalTmaInCall =
          this.tma.filter((tma) => tma.status === "in call").length || 0;
      } catch (error) {
        this.tma = [];
      }
      this.isGetAgentsStart = false;
    },

    selectDoctorFilterStatus(status) {
      this.doctorFilterStatus = Object.assign({}, status);
    },

    selectTmaFilterStatus(status) {
      this.tmaFilterStatus = Object.assign({}, status);
    },
  },

  async created() {
    await this.getDoctors();
    await this.getAgents();
  },
};
</script>

<style lang="scss" scoped>
.dropdown-enter-active,
.dropdown-leave-active {
  transition: width 0.3s;
}

.dropdown-enter,
.dropdown-leave-to {
  width: initial;
}

.line-border {
  border-right: 5px solid #258bf5;
}

.line-holder {
  border-right: 5px solid transparent;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-left: 12px;
  margin-right: 12px;

  th {
    font-size: small;
    color: #258bf5;
    padding-top: 10px;
    padding-bottom: 5px;
  }

  .time {
    width: 130px;
  }
}
</style>
